import React from 'react';
import { DropTarget } from 'react-dnd';
import _ from 'lodash';
import cx from 'classnames';
import DropTargetContainer from "../drag-drop/drop-target-container";
import DraggableItem from "../drag-drop/DraggableItem";
import StitchBox from './StitchBox';
import './request.scss';

const BlackAsset = {
    "key" : "black",
    "assetName": "1 Second Black",
    "additionalFields": {
        "idNo": "BLACK"
    }
};

const collect = (connect, monitor) => {
    return {
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({shallow: true}),
        canDrop: monitor.canDrop(),
        itemType: monitor.getItemType()
    };
};

const dropTargetHandler = {
    drop(props, monitor, component) {
        const data = monitor.getItem().data;
        const sources = data.sources;
        const stitchedKeys = component.state.stitchedKeys;
        const dropResult = monitor.getDropResult();
        const dropIndex = _.has(dropResult, 'dropIndex') ? dropResult.dropIndex : stitchedKeys.length;
        const currentIndex = data.currentIndex;
        const keys = _.map(sources, (source)=>source.key);

        if (_.isUndefined(currentIndex)) {
            stitchedKeys.splice.apply(stitchedKeys, [dropIndex, 0].concat(keys));
        }
        else if (currentIndex <= dropIndex) {
            //add then remove
            stitchedKeys.splice.apply(stitchedKeys, [dropIndex, 0].concat(keys));
            stitchedKeys.splice(currentIndex, sources.length);
        }
        else {
            //remove then add
            stitchedKeys.splice(currentIndex, sources.length);
            stitchedKeys.splice.apply(stitchedKeys, [dropIndex, 0].concat(keys));
        }
        const uniqueStitchedKeys = Array.from(new Set(stitchedKeys));

        component.setState({
            stitchedKeys: uniqueStitchedKeys
        });

        component.props.onStitchChange(uniqueStitchedKeys);

        return {moved: true};
    }
};

class StitchList extends React.Component {
    state = {
        sourcesByKey: _.groupBy(this.props.sources, 'key'),
        stitchedKeys: this.props.stitchedKeys || []
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            sourcesByKey: _.groupBy(nextProps.sources, 'key')
        });
        this.setState({ stitchedKeys: [...new Set(nextProps.stitchedKeys)] });
    }

    removeSources = (indices) => {
        const newStitchedKeys = this.state.stitchedKeys.slice(0);
        _.pullAt(newStitchedKeys, indices);
        this.setState({stitchedKeys: newStitchedKeys});
        this.props.onStitchChange(newStitchedKeys);
    }

    renderStitchedSources() {
        const state = this.state;
        return (
            _.map([...new Set(this.state.stitchedKeys)], (key, index) => {
                const source = _.first(state.sourcesByKey[key]) || BlackAsset;

                if (source.key !== BlackAsset.key) {
                    return this.renderSingleSource(index, source);
                }
            })
        );
    }

    renderSingleSource(index, source) {
        const summaryFields = this.props.summaryFields;
        const canEdit = this.props.canDrag;
        const data = {
            sources: [source],
            currentIndex: index
        };
        return (
            <DraggableItem
                key={"drag-source" + index}
                data={data}
                canDrag={this.props.canDrag}
                nonEditable
                noPadding
                noScroll>
                <DropTargetContainer dropIndex={index}>
                    <StitchBox key={source.key+':'+index}
                                onCopy={_.noop}
                                onDelete={canEdit ? _.partial(this.removeSources,[index]) : _.noop}
                                title={source.assetName} data={source}
                                summaryFields={summaryFields}></StitchBox>
                </DropTargetContainer>
            </DraggableItem>
        );
    }

    render() {
        const isOverCurrent = this.props.isOverCurrent;
        const connectDropTarget = this.props.connectDropTarget;
        const isEmpty = _.isEmpty(this.state.stitchedKeys);
        let canDrop = this.props.canDrop;
        let isOver = this.props.isOver;
        const dragClasses = cx({
            'empty': isEmpty,
            'invalid': this.state.invalid,
            'drag-area': true,
            'over': isOverCurrent,
            'dragItemsUl' : true
        });

        return connectDropTarget(
            <div className={dragClasses}
                 style={{
                     boxShadow: isOver && canDrop ? "0 0 0 .3rem rgba(0,123,255,.25)" : ""}}>
                {this.renderStitchedSources()}
                <div className="stitchDropInfo">
                    { isEmpty ?
                        "To add a source, drag items from the left."
                        : "Drag here to add to end of stitching"
                    }
                </div>
            </div>
        );
    }
}

// @ts-ignore
export default new DropTarget(['source'], dropTargetHandler, collect)(StitchList);
